// ============================================================================
// SUBPRODUCTOS / ALIADOS DE AFILIADO  —  modelo de "peso cero"
// ----------------------------------------------------------------------------
// Son productos de terceros. NO mantenemos infraestructura, inventario ni
// soporte: solo los mostramos para quien pregunte.
//
//   • Si el producto tiene `affiliateLink`  -> el botón lleva a tu enlace de
//     afiliado y ganas comisión (cero trabajo).
//   • Si NO tiene `affiliateLink` (cadena vacía) -> el botón abre WhatsApp
//     para consultar. Útil mientras consigues el enlace o para venta directa.
//
// CÓMO USAR:
//   - Conseguiste el link de afiliado: pégalo en `affiliateLink`.
//   - Ocultar temporalmente: pon `activo: false`.
//   - Destacar (badge "Recomendado" y primero en la lista): `destacado: true`.
//   - Agregar uno nuevo: copia un bloque, cambia los datos y pega tu link.
//
// 🔁 = programa con comisión RECURRENTE (te paga cada mes). Son los mejores.
// ============================================================================

// Número de WhatsApp para consultas (formato internacional, sin signos).
export const WHATSAPP_NUMBER = '50688228785';

export const subproductos = [
  // ---------------------------- SEGURIDAD -----------------------------------
  {
    id: 'nordvpn',
    nombre: 'NordVPN',
    categoria: 'Seguridad',
    descripcion:
      'La VPN más segura y rápida para empresas y usuarios exigentes. Protege tu privacidad y navega sin límites.',
    logo: 'https://1000logos.net/wp-content/uploads/2022/08/NordVPN-Logo.png',
    caracteristicas: ['Cifrado de nivel militar', '+5500 servidores en 60 países', 'Protección contra malware', 'Hasta 6 dispositivos'],
    cta: 'Obtener con descuento',
    affiliateLink: 'https://refer-nordvpn.com/BqpinCHeumv',
    destacado: true,
    activo: true,
  },
  {
    id: 'nordpass',
    nombre: 'NordPass',
    categoria: 'Seguridad',
    descripcion: 'Gestor de contraseñas para tu equipo. Guarda y comparte accesos de forma segura, sin hojas de cálculo.',
    logo: 'https://logo.clearbit.com/nordpass.com',
    caracteristicas: ['Contraseñas cifradas', 'Compartir accesos en equipo', 'Autocompletado seguro', 'Alertas de filtraciones'],
    cta: 'Ver oferta',
    affiliateLink: '', // TODO: link de afiliado NordPass
    destacado: false,
    activo: true,
  },
  {
    id: 'surfshark',
    nombre: 'Surfshark',
    categoria: 'Seguridad',
    descripcion: 'VPN económica con dispositivos ilimitados. Buena alternativa para equipos con presupuesto ajustado.',
    logo: 'https://logo.clearbit.com/surfshark.com',
    caracteristicas: ['Dispositivos ilimitados', 'Bloqueo de anuncios', 'Modo camuflaje', 'Sin registros'],
    cta: 'Ver oferta',
    affiliateLink: '', // TODO: link de afiliado Surfshark
    destacado: false,
    activo: true,
  },
  {
    id: 'bitdefender',
    nombre: 'Bitdefender',
    categoria: 'Seguridad',
    descripcion: 'Antivirus y protección para los equipos de tu empresa. Defensa contra virus, ransomware y phishing.',
    logo: 'https://logo.clearbit.com/bitdefender.com',
    caracteristicas: ['Protección en tiempo real', 'Anti-ransomware', 'Bajo consumo', 'Windows, Mac y móvil'],
    cta: 'Ver oferta',
    affiliateLink: '', // TODO: link de afiliado Bitdefender
    destacado: false,
    activo: true,
  },
  {
    id: 'norton',
    nombre: 'Norton 360',
    categoria: 'Seguridad',
    descripcion: 'Suite de seguridad todo en uno: antivirus, VPN y respaldo en la nube para hogar y empresa.',
    logo: 'https://logo.clearbit.com/norton.com',
    caracteristicas: ['Antivirus + VPN', 'Respaldo en la nube', 'Monitoreo de identidad', 'Control parental'],
    cta: 'Ver oferta',
    affiliateLink: '', // TODO: link de afiliado Norton
    destacado: false,
    activo: true,
  },
  {
    id: '1password',
    nombre: '1Password',
    categoria: 'Seguridad',
    descripcion: 'Gestor de contraseñas líder para equipos. Acceso seguro y compartido para toda la empresa. 🔁',
    logo: 'https://logo.clearbit.com/1password.com',
    caracteristicas: ['Bóvedas por equipo', 'Acceso seguro compartido', 'Integración con apps', 'Auditoría de accesos'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado 1Password
    destacado: false,
    activo: true,
  },

  // ----------------------------- HOSTING ------------------------------------
  {
    id: 'hostinger',
    nombre: 'Hostinger',
    categoria: 'Hosting',
    descripcion: 'Hosting web rápido y económico para sitios y tiendas. Ideal para arrancar tu presencia digital.',
    logo: 'https://logo.clearbit.com/hostinger.com',
    caracteristicas: ['Hosting web y WordPress', 'SSL incluido', 'Correo profesional', 'Panel fácil de usar'],
    cta: 'Ver planes',
    affiliateLink: '', // TODO: link de afiliado Hostinger
    destacado: false,
    activo: true,
  },
  {
    id: 'cloudways',
    nombre: 'Cloudways',
    categoria: 'Hosting',
    descripcion: 'Hosting gestionado en la nube, rápido y escalable. Favorito de desarrolladores. 🔁',
    logo: 'https://logo.clearbit.com/cloudways.com',
    caracteristicas: ['Cloud gestionado', 'Escalable con 1 clic', 'Respaldo automático', 'Soporte 24/7'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado Cloudways
    destacado: false,
    activo: true,
  },
  {
    id: 'kinsta',
    nombre: 'Kinsta',
    categoria: 'Hosting',
    descripcion: 'Hosting WordPress premium de alto rendimiento. Para sitios que necesitan velocidad y soporte top. 🔁',
    logo: 'https://logo.clearbit.com/kinsta.com',
    caracteristicas: ['WordPress premium', 'Red de Google Cloud', 'CDN incluido', 'Soporte experto'],
    cta: 'Ver planes',
    affiliateLink: '', // TODO: link de afiliado Kinsta
    destacado: false,
    activo: true,
  },
  {
    id: 'siteground',
    nombre: 'SiteGround',
    categoria: 'Hosting',
    descripcion: 'Hosting confiable y recomendado para WordPress, con buen soporte y rendimiento.',
    logo: 'https://logo.clearbit.com/siteground.com',
    caracteristicas: ['Optimizado para WordPress', 'SSL gratis', 'Respaldo diario', 'Soporte valorado'],
    cta: 'Ver planes',
    affiliateLink: '', // TODO: link de afiliado SiteGround
    destacado: false,
    activo: true,
  },
  {
    id: 'digitalocean',
    nombre: 'DigitalOcean',
    categoria: 'Hosting',
    descripcion: 'Servidores en la nube (VPS) para proyectos técnicos y apps a medida. Simple y potente.',
    logo: 'https://logo.clearbit.com/digitalocean.com',
    caracteristicas: ['Droplets (VPS)', 'Bases de datos gestionadas', 'Escalable', 'Pago por uso'],
    cta: 'Obtener crédito',
    affiliateLink: '', // TODO: link de afiliado DigitalOcean
    destacado: false,
    activo: true,
  },
  {
    id: 'vultr',
    nombre: 'Vultr',
    categoria: 'Hosting',
    descripcion: 'Infraestructura cloud económica con servidores en todo el mundo. Buena para VPS y despliegues.',
    logo: 'https://logo.clearbit.com/vultr.com',
    caracteristicas: ['VPS en 30+ regiones', 'Despliegue en segundos', 'Pago por hora', 'Buen precio'],
    cta: 'Obtener crédito',
    affiliateLink: '', // TODO: link de afiliado Vultr
    destacado: false,
    activo: true,
  },

  // ----------------------------- DOMINIOS -----------------------------------
  {
    id: 'namecheap',
    nombre: 'Namecheap',
    categoria: 'Dominios',
    descripcion: 'Registra el dominio de tu empresa a buen precio. La dirección de tu marca en internet.',
    logo: 'https://logo.clearbit.com/namecheap.com',
    caracteristicas: ['Dominios .com, .cr y más', 'Privacidad WHOIS gratis', 'Gestión DNS sencilla', 'Renovación justa'],
    cta: 'Buscar dominio',
    affiliateLink: '', // TODO: link de afiliado Namecheap
    destacado: false,
    activo: true,
  },
  {
    id: 'godaddy',
    nombre: 'GoDaddy',
    categoria: 'Dominios',
    descripcion: 'El registrador de dominios más conocido. Ideal para clientes que buscan una marca de confianza.',
    logo: 'https://logo.clearbit.com/godaddy.com',
    caracteristicas: ['Dominios y hosting', 'Correo profesional', 'Constructor de webs', 'Soporte telefónico'],
    cta: 'Buscar dominio',
    affiliateLink: '', // TODO: link de afiliado GoDaddy
    destacado: false,
    activo: true,
  },

  // ---------------------------- E-COMMERCE / WEB ----------------------------
  {
    id: 'shopify',
    nombre: 'Shopify',
    categoria: 'E-commerce',
    descripcion: 'La plataforma líder para crear tu tienda en línea. Ideal para clientes que quieren vender ya.',
    logo: 'https://logo.clearbit.com/shopify.com',
    caracteristicas: ['Tienda lista en horas', 'Pagos integrados', 'Miles de apps', 'Vende en redes sociales'],
    cta: 'Empezar gratis',
    affiliateLink: '', // TODO: link de afiliado Shopify
    destacado: false,
    activo: true,
  },
  {
    id: 'elementor',
    nombre: 'Elementor',
    categoria: 'Web',
    descripcion: 'Constructor visual para WordPress. Crea páginas profesionales sin programar. 🔁',
    logo: 'https://logo.clearbit.com/elementor.com',
    caracteristicas: ['Editor visual', 'Cientos de plantillas', 'Diseño responsivo', 'Sin código'],
    cta: 'Ver planes',
    affiliateLink: '', // TODO: link de afiliado Elementor
    destacado: false,
    activo: true,
  },
  {
    id: 'envato',
    nombre: 'Envato Elements',
    categoria: 'Web',
    descripcion: 'Plantillas, gráficos, fotos y recursos ilimitados para tus proyectos. Imprescindible para agencias. 🔁',
    logo: 'https://logo.clearbit.com/envato.com',
    caracteristicas: ['Plantillas web ilimitadas', 'Stock de fotos y video', 'Gráficos y fuentes', 'Licencia comercial'],
    cta: 'Ver Elements',
    affiliateLink: '', // TODO: link de afiliado Envato
    destacado: false,
    activo: true,
  },

  // -------------------------- EMAIL MARKETING (🔁) --------------------------
  {
    id: 'brevo',
    nombre: 'Brevo',
    categoria: 'Email Marketing',
    descripcion: 'Email marketing y automatización para PYMES (antes Sendinblue). Plan gratis para empezar. 🔁',
    logo: 'https://logo.clearbit.com/brevo.com',
    caracteristicas: ['Campañas de email', 'Automatización', 'SMS y WhatsApp', 'CRM básico'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado Brevo
    destacado: false,
    activo: true,
  },
  {
    id: 'getresponse',
    nombre: 'GetResponse',
    categoria: 'Email Marketing',
    descripcion: 'Email marketing, embudos de venta y páginas de aterrizaje en una sola herramienta. 🔁',
    logo: 'https://logo.clearbit.com/getresponse.com',
    caracteristicas: ['Email y automatización', 'Embudos de venta', 'Landing pages', 'Webinars'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado GetResponse
    destacado: false,
    activo: true,
  },
  {
    id: 'activecampaign',
    nombre: 'ActiveCampaign',
    categoria: 'Email Marketing',
    descripcion: 'Automatización de marketing y CRM potente para empresas que quieren escalar sus ventas. 🔁',
    logo: 'https://logo.clearbit.com/activecampaign.com',
    caracteristicas: ['Automatización avanzada', 'CRM de ventas', 'Segmentación', 'Email + SMS'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado ActiveCampaign
    destacado: false,
    activo: true,
  },
  {
    id: 'kit',
    nombre: 'Kit',
    categoria: 'Email Marketing',
    descripcion: 'Email marketing para creadores y negocios pequeños (antes ConvertKit). Simple y efectivo. 🔁',
    logo: 'https://logo.clearbit.com/kit.com',
    caracteristicas: ['Email para creadores', 'Automatización simple', 'Formularios', 'Plan gratis'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado Kit
    destacado: false,
    activo: true,
  },

  // ---------------------------- PRODUCTIVIDAD -------------------------------
  {
    id: 'canva',
    nombre: 'Canva Pro',
    categoria: 'Productividad',
    descripcion: 'Diseño gráfico fácil para tu marca: redes, presentaciones y publicidad sin diseñador.',
    logo: 'https://logo.clearbit.com/canva.com',
    caracteristicas: ['Miles de plantillas', 'Kit de marca', 'Quitar fondos en 1 clic', 'Colaboración'],
    cta: 'Probar Canva Pro',
    affiliateLink: '', // TODO: link de afiliado Canva
    destacado: false,
    activo: false, // Programa de afiliados cerrado (TESTI-14): no se ofrece.
  },
  {
    id: 'notion',
    nombre: 'Notion',
    categoria: 'Productividad',
    descripcion: 'Espacio de trabajo todo en uno: notas, documentos, tareas y bases de datos para tu equipo.',
    logo: 'https://logo.clearbit.com/notion.so',
    caracteristicas: ['Notas y documentos', 'Gestión de proyectos', 'Wikis de equipo', 'Plantillas'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado Notion
    destacado: false,
    activo: false, // Programa de afiliados cerrado (TESTI-14): no se ofrece.
  },
  {
    id: 'grammarly',
    nombre: 'Grammarly',
    categoria: 'Productividad',
    descripcion: 'Asistente de escritura que corrige y mejora tus textos en inglés. Útil para comunicación profesional.',
    logo: 'https://logo.clearbit.com/grammarly.com',
    caracteristicas: ['Corrección en tiempo real', 'Tono y claridad', 'Funciona en el navegador', 'Plan gratis'],
    cta: 'Ver oferta',
    affiliateLink: '', // TODO: link de afiliado Grammarly
    destacado: false,
    activo: true,
  },

  // ------------------------------ CRM / NEGOCIO -----------------------------
  {
    id: 'hubspot',
    nombre: 'HubSpot',
    categoria: 'CRM',
    descripcion: 'CRM y plataforma de marketing y ventas para hacer crecer tu negocio. CRM gratis para empezar. 🔁',
    logo: 'https://logo.clearbit.com/hubspot.com',
    caracteristicas: ['CRM gratuito', 'Marketing y ventas', 'Automatización', 'Reportes'],
    cta: 'Empezar gratis',
    affiliateLink: '', // TODO: link de afiliado HubSpot
    destacado: false,
    activo: true,
  },
  {
    id: 'zoho',
    nombre: 'Zoho',
    categoria: 'CRM',
    descripcion: 'Suite completa de apps de negocio (CRM, facturación, correo) a precio accesible para PYMES. 🔁',
    logo: 'https://logo.clearbit.com/zoho.com',
    caracteristicas: ['CRM y ventas', 'Facturación', 'Correo y oficina', 'Precio accesible'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado Zoho
    destacado: false,
    activo: true,
  },
  {
    id: 'monday',
    nombre: 'monday.com',
    categoria: 'CRM',
    descripcion: 'Plataforma visual para gestionar proyectos, tareas y equipos. Flexible para cualquier flujo de trabajo. 🔁',
    logo: 'https://logo.clearbit.com/monday.com',
    caracteristicas: ['Tableros visuales', 'Automatizaciones', 'Para equipos', 'Integraciones'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado monday.com
    destacado: false,
    activo: true,
  },
  {
    id: 'clickup',
    nombre: 'ClickUp',
    categoria: 'CRM',
    descripcion: 'Gestión de proyectos y productividad todo en uno. Tareas, docs y metas en un solo lugar. 🔁',
    logo: 'https://logo.clearbit.com/clickup.com',
    caracteristicas: ['Tareas y proyectos', 'Documentos', 'Metas y paneles', 'Plan gratis generoso'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado ClickUp
    destacado: false,
    activo: true,
  },

  // -------------------------------- SEO -------------------------------------
  {
    id: 'semrush',
    nombre: 'Semrush',
    categoria: 'SEO',
    descripcion: 'Herramienta de SEO y marketing digital para posicionar a tus clientes en Google. 🔁',
    logo: 'https://logo.clearbit.com/semrush.com',
    caracteristicas: ['Investigación de keywords', 'Análisis de competencia', 'Auditoría SEO', 'Seguimiento de posiciones'],
    cta: 'Probar gratis',
    affiliateLink: '', // TODO: link de afiliado Semrush
    destacado: false,
    activo: true,
  },
];

// Devuelve los subproductos activos, con los destacados primero.
export const getSubproductos = () =>
  subproductos
    .filter((p) => p.activo)
    .sort((a, b) => Number(b.destacado) - Number(a.destacado));

// Categorías presentes (para filtros futuros si se quieren).
export const categorias = [...new Set(subproductos.filter((p) => p.activo).map((p) => p.categoria))];

// Construye un enlace de WhatsApp para consultar por un producto.
export const whatsappConsulta = (nombre) =>
  `https://wa.me/+${WHATSAPP_NUMBER}?text=` +
  encodeURIComponent(`Hola, me interesa ${nombre}. ¿Me das más información?`);
